import { render, staticRenderFns } from "./NewJdc.vue?vue&type=template&id=26be6cf4&scoped=true"
import script from "./NewJdc.vue?vue&type=script&lang=js"
export * from "./NewJdc.vue?vue&type=script&lang=js"
import style0 from "./NewJdc.vue?vue&type=style&index=0&id=26be6cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be6cf4",
  null
  
)

export default component.exports